// This file was automatically generated from appchart.providers.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.providers');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.physicians');
goog.require('el8.template.util.format');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tabbed-nav"></div><div class="provider-list-container el8ProviderDipdown"><div class="provider-list-section el8ProviderListSection">');
  el8.template.appchart.providers.patientTeam(opt_data, output);
  output.append('</div><div class="provider-search-section el8ProviderSearchSection">');
  el8.template.appchart.providers.searchBar(null, output);
  output.append('<div class="provider-search-results">');
  el8.template.appchart.providers.searchCategories(opt_data, output);
  output.append('</div>', (el8Globals.FEATURES.RibbonEpn) ? '<div class="el8ProviderSearchRibbonLabel">Powered by Ribbon</div>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeam = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ProviderListHeader"><span>Care Team<span class="care-team-providers-icon el8PLHeaderQTip">?</span></span></div><ul class="el8ProviderList">');
  var pList4171 = opt_data.careTeamWithMainProviders;
  var pListLen4171 = pList4171.length;
  for (var pIndex4171 = 0; pIndex4171 < pListLen4171; pIndex4171++) {
    var pData4171 = pList4171[pIndex4171];
    if (pData4171.isCareTeamModel) {
      el8.template.appchart.providers.careTeamEntry({provider: pData4171, collaboratorPractices: opt_data.collaboratorPractices}, output);
    } else {
      el8.template.appchart.providers.providerEntry({provider: pData4171, collaboratorPractices: opt_data.collaboratorPractices}, output);
    }
  }
  output.append('</ul><!--<div class="el8ProviderListNoResults care-team-no-member-prompt el8Hidden">You don’t have anyone in your Care Team yet. Add Care Team members to start accessing their shared chart information.<br /><a class="add-care-team-member-trigger" type="button">Add to Care Team</a></div>-->');
  if (opt_data.inactiveCareTeamWithOtherProviders.length) {
    output.append('<div class="el8ProviderListHeader"><span>Other Providers<span class="care-team-other-providers-icon el8PLHeaderQTip">?</span></span></div><ul class="el8ProviderList">');
    var pList4186 = opt_data.inactiveCareTeamWithOtherProviders;
    var pListLen4186 = pList4186.length;
    for (var pIndex4186 = 0; pIndex4186 < pListLen4186; pIndex4186++) {
      var pData4186 = pList4186[pIndex4186];
      if (pData4186.isCareTeamModel) {
        el8.template.appchart.providers.careTeamEntry({provider: pData4186, collaboratorPractices: opt_data.collaboratorPractices}, output);
      } else {
        el8.template.appchart.providers.providerEntry({provider: pData4186, collaboratorPractices: opt_data.collaboratorPractices}, output);
      }
    }
    output.append('</ul>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamEntry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="care-team-entry am-highlight el8ProviderListEntry el8CareTeamListEntry" data-id="', soy.$$escapeHtml(opt_data.provider.id), '">');
  el8.template.data.physicians.icon(soy.$$augmentData(opt_data.provider.physician, {isCurrentUser: opt_data.provider.isCurrentUser, isActivePlr: opt_data.provider.isActive, isSharingPlr: opt_data.provider.isSharingEnabled, isInvitePendingPlr: opt_data.provider.isInvitePending, providerLogo: opt_data.provider.providerLogo}), output);
  output.append('<div class="el8PLActionsMenu care-team-action-button"><span class="el8IconSettings16"></span><span class="el8PLActionsMenuArrow"></span></div><p class="mr20"><a><span class="care-team-name-trigger ', (el8Globals.FEATURES.PLR4Everyone) ? (opt_data.provider.isInvitePending) ? 'el8MainProviderNameNoPlr' : (opt_data.provider.isActive && opt_data.provider.isSharingEnabled) ? 'el8MainProviderNameWithPlr' : (! opt_data.provider.isActive && opt_data.provider.isSharingEnabled) ? 'el8MainProviderNameNoPlr' : 'el8MainProviderNamePartialPlr' : 'el8MainProviderName', '" data-id="', soy.$$escapeHtml(opt_data.provider.physician.id), '">', (opt_data.provider.physician.isPcp) ? '(PCP) ' : '', soy.$$escapeHtml(opt_data.provider.physician.reverseName), (opt_data.provider.practicingStatus == 'retired') ? ' (retired)' : '', (opt_data.provider.isCurrentUser) ? ' (you)' : (opt_data.provider.isPracticeUser) ? ' (in this practice)' : '', '</span></a>');
  if (opt_data.provider.physician.isEConfirmed) {
    el8.template.data.physicians.verifiedCheck(null, output);
  }
  output.append((opt_data.provider.isInvitePending) ? ' <span class="el8ItalicText el8BrandDark">(invited ' + (soy.$$escapeHtml(opt_data.provider.invitationDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.provider.invitationDate)) : '') + ')</span>' : '', '</p>');
  if (opt_data.provider.physician.specialties && opt_data.provider.physician.specialties.length) {
    output.append('<p class="padt2 el8Bold">');
    el8.template.data.physicians.specialtyList(opt_data.provider.physician, output);
    output.append('</p>');
  }
  output.append((opt_data.provider.physician.ssClinicName) ? '<p class="padt2 el8PLText">' + soy.$$escapeHtml(opt_data.provider.physician.ssClinicName) + '</p>' : '', (opt_data.provider.enterprise) ? '<p><span class="el8TagItemForEnterprise el8AlignCenter">' + soy.$$escapeHtml(opt_data.provider.enterprise.name) + '</span></p>' : '', (opt_data.provider.physician.city || opt_data.provider.physician.state) ? '<p class="padt2">' + ((opt_data.provider.physician.city && opt_data.provider.physician.state) ? '<span class="el8PLText mr5">' + soy.$$escapeHtml(opt_data.provider.physician.city) + ', ' + soy.$$escapeHtml(opt_data.provider.physician.state) + '</span>' : (opt_data.provider.physician.city) ? '<span class="el8PLText mr5">' + soy.$$escapeHtml(opt_data.provider.physician.city) + '</span>' : (opt_data.provider.physician.state) ? '<span class="el8PLText mr5">' + soy.$$escapeHtml(opt_data.provider.physician.state) + '</span>' : '') + '</p>' : '', (opt_data.provider.physician.phone) ? '<p class="padt2">(T) ' + soy.$$escapeHtml(opt_data.provider.physician.phone) + '</p>' : '');
  if (opt_data.provider.note) {
    el8.template.appchart.providers.careTeamProviderNoteSection(opt_data, output);
  } else {
    output.append('<span class="care-team-entry-note-section"></span>');
  }
  output.append((! opt_data.provider.isCurrentUser) ? '<div class="padt10">' + ((opt_data.provider.isPracticeUser) ? '<a class="care-team-write-message-trigger el8PLActionLink padr10">Office Message</a>' : '<a class="care-team-write-letter-trigger el8PLActionLink padr10">Letter</a><a class="care-team-write-referral-trigger el8PLActionLink padr10">Referral</a>') + ((! opt_data.provider.isInvitePending) ? '<a class="care-team-add-treating-trigger el8PLActionLink padr10">Notes</a>' : '') + '</div>' : '', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.patientTeam = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (el8Globals.FEATURES.PLR4Everyone) {
    el8.template.appchart.providers.careTeam(opt_data, output);
  } else {
    if (! opt_data.mainProviders.length && ! opt_data.otherProviders.length) {
      output.append('<p class="el8ProviderListNoResults">This patient does not have any providers yet. Add providers using Provider Search or the Add Provider button in the Clinical Profile.</p><p class="el8AlignCenter"><button class="el8button show-search-tab" type="button">Search for Providers</button></p>');
    } else {
      if (opt_data.mainProviders.length) {
        output.append('<div class="el8ProviderListHeader"><span>Provider List<span class="main-providers-icon el8PLHeaderQTip">?</span></span></div><ul class="el8ProviderList">');
        el8.template.appchart.providers.providerList(soy.$$augmentData(opt_data, {list: opt_data.mainProviders}), output);
        output.append('</ul>');
      }
      if (opt_data.otherProviders.length) {
        output.append('<div class="el8ProviderListHeader"><span>Other Providers<span class="other-providers-icon el8PLHeaderQTip">?</span></span></div><ul class="el8ProviderList">');
        el8.template.appchart.providers.providerList(soy.$$augmentData(opt_data, {list: opt_data.otherProviders}), output);
        output.append('</ul>');
      }
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.searchSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="search-results-section">');
  if (opt_data.list.length) {
    output.append('<div class="el8ProviderListSecondaryHeader"><span class="el8ProviderListHeaderArrow"></span><span>Providers involved in patient\'s care:</span></div><ul class="local-results el8ProviderList">');
    el8.template.appchart.providers.providerList(opt_data, output);
    output.append('</ul>');
  }
  output.append('<div class="fetch-connections-results"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.providerList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var pList4337 = opt_data.list;
  var pListLen4337 = pList4337.length;
  for (var pIndex4337 = 0; pIndex4337 < pListLen4337; pIndex4337++) {
    var pData4337 = pList4337[pIndex4337];
    el8.template.appchart.providers.providerEntry({provider: pData4337, collaboratorPractices: opt_data.collaboratorPractices}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.searchBar = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ProviderListFilter"><input type="text" size="30" placeholder="Type a Specialty or Provider Name..." class="w100" name="filterSpecialty" /></div><div class="el8ProviderListRestart"><div class="reveal-post-search" style="display: none"><p class="el8PLFilterSummary"><span class="filter-summary"></span> <a class="filter-collapse-trigger ml5"></a></p><div class="filter-collapsible-section"><div><p class="el8PLFilterLabel">City:</p><input type="text" class="city-filter mr0 el8PLInput el8TextareaWrap" placeholder="Enter a city" name="city" autocomplete="off" /></div><div><p class="el8PLFilterLabel">State:</p><input type="text" class="state-filter mr0 el8PLInput el8TextareaWrap" placeholder="Enter a state" name="state" maxlength="2" autocomplete="off" /></div></div></div><button class="el8button clear-filter-trigger reveal-post-search el8ShortButton" style="display: none">Back to specialty list</button><button class="el8button do-filter-trigger el8ShortButton el8PrimaryButton ebs-btn ebs-btn-primary ml5">Search</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.filterSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.city && opt_data.state) ? 'showing results in ' + soy.$$escapeHtml(opt_data.city) + ', ' + soy.$$escapeHtml(opt_data.state) : (opt_data.city) ? 'showing results in ' + soy.$$escapeHtml(opt_data.city) : (opt_data.state) ? 'showing results in ' + soy.$$escapeHtml(opt_data.state) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.searchCategories = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var cList4358 = opt_data.specialtyCategories;
  var cListLen4358 = cList4358.length;
  if (cListLen4358 > 0) {
    for (var cIndex4358 = 0; cIndex4358 < cListLen4358; cIndex4358++) {
      var cData4358 = cList4358[cIndex4358];
      output.append('<a class="fetch-connections-trigger el8SpecialtyCategories" data-id="', soy.$$escapeHtml(cData4358.id), '">', soy.$$escapeHtml(cData4358.name), '</a>');
    }
  } else {
    output.append('<a class="fetch-connections-trigger el8SpecialtyCategories" data-id="0">(Unknown)</a>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.providerEntry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="provider-entry am-highlight el8ProviderListEntry', (opt_data.provider.group != 'main') ? ' el8OtherProvider' : '', '" data-id="', soy.$$escapeHtml(opt_data.provider.id), '">');
  el8.template.data.physicians.icon(soy.$$augmentData(opt_data.provider.physician, {providerLogo: opt_data.provider.providerLogo}), output);
  output.append('<div class="el8PLActionsMenu provider-action-button"><span class="el8IconSettings16"></span><span class="el8PLActionsMenuArrow"></span></div><p class="mr20"><a><span class="provider-name-trigger ', (el8Globals.FEATURES.PLR4Everyone) ? 'el8MainProviderNameNoPlr' : 'el8MainProviderName', '" data-id="', soy.$$escapeHtml(opt_data.provider.physician.id), '">', (opt_data.provider.physician.isPcp) ? '(PCP) ' : '', soy.$$escapeHtml(opt_data.provider.physician.reverseName), (opt_data.provider.practicingStatus == 'retired') ? ' (retired)' : '', '</span></a>');
  if (opt_data.provider.physician.isEConfirmed) {
    el8.template.data.physicians.verifiedCheck(null, output);
  }
  output.append('</p>');
  if (opt_data.provider.physician.specialties && opt_data.provider.physician.specialties.length) {
    output.append('<p class="padt2 ', (! el8Globals.FEATURES.PLR4Everyone) ? 'el8Bold' : '', '">');
    el8.template.data.physicians.specialtyList(opt_data.provider.physician, output);
    output.append('</p>');
  }
  output.append((opt_data.provider.physician.ssClinicName) ? '<p class="padt2 el8PLText">' + soy.$$escapeHtml(opt_data.provider.physician.ssClinicName) + '</p>' : '', (opt_data.provider.enterprise) ? '<p><span class="el8TagItemForEnterprise el8AlignCenter">' + soy.$$escapeHtml(opt_data.provider.enterprise.name) + '</span></p>' : '', (opt_data.provider.physician.city || opt_data.provider.physician.state || opt_data.provider.physician.fax || opt_data.provider.physician.email || opt_data.provider.physician.directAddress) ? '<p class="padt2">' + ((opt_data.provider.physician.city && opt_data.provider.physician.state) ? '<span class="el8PLText el8AddressText mr5">' + soy.$$escapeHtml(opt_data.provider.physician.city) + ', ' + soy.$$escapeHtml(opt_data.provider.physician.state) + '</span>' : (opt_data.provider.physician.city) ? '<span class="el8PLText el8AddressText mr5">' + soy.$$escapeHtml(opt_data.provider.physician.city) + '</span>' : (opt_data.provider.physician.state) ? '<span class="el8PLText el8AddressText mr5">' + soy.$$escapeHtml(opt_data.provider.physician.state) + '</span>' : '') + ((opt_data.provider.physician.directAddress) ? '<span class="el8TagItem mr5">direct</span>' : '') + ((opt_data.provider.physician.fax) ? '<span class="el8TagItem mr5">fax</span>' : '') + ((opt_data.provider.physician.email) ? '<span class="el8TagItem">email</span>' : '') + '</p>' : '', (el8Globals.FEATURES.PLR4Everyone && opt_data.provider.physician.phone) ? '<p class="padt2 el8AddressText">(T) ' + soy.$$escapeHtml(opt_data.provider.physician.phone) + '</p>' : '', (! el8Globals.FEATURES.PLR && _.contains(opt_data.collaboratorPractices, opt_data.provider.physician.accessPracticeId)) ? '<p class="padv5"><span class="el8ProviderListPLRIcon"></span><span class="el8ProviderListPLR">Sharing record with this practice</span></p>' : '', (opt_data.provider.lastMedFillDate) ? '<p class="padt2"><i>Last fill for prescribed med: ' + (soy.$$escapeHtml(opt_data.provider.lastMedFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.provider.lastMedFillDate)) : '') + '</i></p>' : '');
  if (opt_data.provider.lastCareEventDate) {
    output.append('<p class="padt2"><i>Last care event: ', (soy.$$escapeHtml(opt_data.provider.lastCareEventDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.provider.lastCareEventDate)) : ''), '</i> <a class="toggle-care-event-history el8777 el8SmallFontSize">Details</a></p><div class="care-event-history padv5" style="display:none;display:hidden;">');
    var eList4465 = opt_data.provider.careEventDetails;
    var eListLen4465 = eList4465.length;
    for (var eIndex4465 = 0; eIndex4465 < eListLen4465; eIndex4465++) {
      var eData4465 = eList4465[eIndex4465];
      if (eData4465.count > 0) {
        output.append('<p class="headerNote">', soy.$$escapeHtml(eData4465.count), ' ');
        switch (eData4465.careEvent) {
          case 'referral':
            output.append('referral', (eData4465.count != 1) ? 's' : '');
            break;
          case 'letter':
            output.append('letter', (eData4465.count != 1) ? 's' : '');
            break;
          case 'medorder':
            output.append('med', (eData4465.count != 1) ? 's' : '', ' prescribed');
            break;
          case 'immunization':
            output.append('immunization', (eData4465.count != 1) ? 's' : '', ' administered');
            break;
          case 'consultation_report':
            output.append('consult report', (eData4465.count != 1) ? 's' : '');
            break;
          case 'order':
            output.append('order', (eData4465.count != 1) ? 's' : '', ' cc\'d');
            break;
        }
        output.append((! eData4465.latestActivity) ? ' on ' + (soy.$$escapeHtml(eData4465.earliestActivity)? el8.service.tz.soyDate(soy.$$escapeHtml(eData4465.earliestActivity)) : '') + '.' : ' between ' + (soy.$$escapeHtml(eData4465.earliestActivity)? el8.service.tz.soyDate(soy.$$escapeHtml(eData4465.earliestActivity)) : '') + ' and ' + (soy.$$escapeHtml(eData4465.latestActivity)? el8.service.tz.soyDate(soy.$$escapeHtml(eData4465.latestActivity)) : '') + '.', '</p>');
      }
    }
    output.append('</div>');
  }
  el8.template.appchart.providers.insuranceStatus({status: opt_data.provider.physician.acceptingInsurance}, output);
  el8.template.appchart.providers.newPatientStatus({status: opt_data.provider.physician.acceptingNewPatients}, output);
  if (opt_data.provider.treatmentReason) {
    el8.template.appchart.providers.treatmentReasonSection(opt_data, output);
  } else {
    output.append('<span class="provider-entry-treating-section"></span>');
  }
  output.append('<div class="padt5">', (opt_data.provider.isPracticeUser) ? '<a class="provider-write-message-trigger el8PLActionLink padr10">Office Message</a>' : '<a class="provider-write-letter-trigger el8PLActionLink padr10">Letter</a><a class="provider-write-referral-trigger el8PLActionLink padr10">Referral</a>', '<a class="provider-add-treating-trigger el8PLActionLink padr10">Notes</a></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.treatmentReasonSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TreatingSection"><label class="el8label el8TreatingLabel">Notes:</label><div class="el8TreatingTextarea provider-entry-treating-field" data-id="', soy.$$escapeHtml(opt_data.provider.id), '"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamProviderNoteSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TreatingSection"><label class="el8label el8TreatingLabel">Notes:</label><div class="el8TreatingTextarea care-team-entry-note-field" data-id="', soy.$$escapeHtml(opt_data.provider.id), '"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.connectionResults = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.networkResults.length) {
    output.append('<div class="el8ProviderListSecondaryHeader"><span class="el8ProviderListHeaderArrow"></span><span>Additional Providers in Your Network:</span></div><ul class="el8ProviderList">');
    var itemList4550 = opt_data.networkResults;
    var itemListLen4550 = itemList4550.length;
    for (var itemIndex4550 = 0; itemIndex4550 < itemListLen4550; itemIndex4550++) {
      var itemData4550 = itemList4550[itemIndex4550];
      el8.template.appchart.providers.connectionResult({item: itemData4550}, output);
    }
    output.append('</ul>');
  }
  if (opt_data.npiResults.length) {
    output.append('<div class="el8ProviderListSecondaryHeader"><span class="el8ProviderListHeaderArrow"></span><span>Providers Outside of Your Network:</span></div><ul class="el8ProviderList">');
    var itemList4558 = opt_data.npiResults;
    var itemListLen4558 = itemList4558.length;
    for (var itemIndex4558 = 0; itemIndex4558 < itemListLen4558; itemIndex4558++) {
      var itemData4558 = itemList4558[itemIndex4558];
      el8.template.appchart.providers.connectionResult({item: itemData4558}, output);
    }
    output.append('</ul>');
  }
  output.append((opt_data.numTeamMembers == 0 && ! opt_data.networkResults.length && ! opt_data.npiResults.length) ? '<div class="el8ProviderListNoResults">No providers with this specialty were found in your network.</div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.connectionResult = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.item.model_class == 'CMSPhysician') ? '<li class="connection-entry el8ProviderListEntry el8OtherProvider el8ProviderListMinHeight" data-id="' + soy.$$escapeHtml(opt_data.item.npi) + '">' : '<li class="connection-entry el8ProviderListEntry el8OtherProvider el8ProviderListMinHeight" data-id="' + soy.$$escapeHtml(opt_data.item.id) + '">');
  el8.template.data.physicians.icon({accessUserId: opt_data.item.public_access_user_id, providerLogo: opt_data.item.provider_logo, isOrg: opt_data.item.is_org, isNotMapped: ! ! opt_data.item.is_not_mapped}, output);
  output.append('<p>', (opt_data.item.model_class == 'CMSPhysician') ? '<span class="' + ((el8Globals.FEATURES.PLR4Everyone) ? 'el8MainProviderNameNoPlr' : 'el8MainProviderName') + '">' + soy.$$escapeHtml(opt_data.item.reverse_name) + '</span>' : '<a><span class="connection-name-trigger ' + ((el8Globals.FEATURES.PLR4Everyone) ? 'el8MainProviderNameNoPlr' : 'el8MainProviderName') + '">' + soy.$$escapeHtml(opt_data.item.reverse_name) + ((opt_data.item.practicing_status == 'retired') ? ' (retired)' : '') + '</span></a>');
  if (opt_data.item.is_e_confirmed) {
    el8.template.data.physicians.verifiedCheck(null, output);
  }
  output.append('</p>');
  if (opt_data.item.specialties && opt_data.item.specialties.length) {
    output.append('<p class="el8PLText el8ItalicText padt2">');
    el8.template.util.format.commaSeparate({list: opt_data.item.specialties}, output);
    output.append('</p>');
  }
  output.append((opt_data.item.ss_clinic_name) ? '<p class="padt2 el8PLText">' + soy.$$escapeHtml(opt_data.item.ss_clinic_name) + '</p>' : '', (opt_data.item.city || opt_data.item.state || opt_data.item.fax || opt_data.item.email || opt_data.item.direct_address) ? '<p class="padt2">' + ((opt_data.item.city || opt_data.item.state) ? '<span class="el8PLText mr5">' + ((opt_data.item.city) ? soy.$$escapeHtml(opt_data.item.city) : '') + ((opt_data.item.state) ? ((opt_data.item.city) ? ', ' : '') + soy.$$escapeHtml(opt_data.item.state) : '') + '</span>' : '') + ((opt_data.item.direct_address) ? '<span class="el8TagItem mr5">direct</span>' : '') + ((opt_data.item.fax) ? '<span class="el8TagItem mr5">fax</span>' : '') + ((opt_data.item.email) ? '<span class="el8TagItem">email</span>' : '') + '</p>' : '');
  el8.template.appchart.providers.insuranceStatus({status: opt_data.item.accepting_insurance}, output);
  el8.template.appchart.providers.newPatientStatus({status: opt_data.item.accepting_new_patients}, output);
  output.append('<div class="padt5">', (opt_data.item.is_practice_user) ? '<a class="connection-write-message-trigger el8PLActionLink padr10">Office Message</a>' : '<a class="connection-write-letter-trigger el8PLActionLink padr10">Letter</a><a class="connection-write-referral-trigger el8PLActionLink padr10">Referral</a>', (el8Globals.FEATURES.PLR4Everyone) ? '<a class="connection-add-main-trigger el8PLActionLink">Add to Care Team</a>' : '<a class="connection-add-main-trigger el8PLActionLink">Add to Providers List</a>', '</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.patientsInCommon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.num != null) ? '<span class="el8PLText">' + soy.$$escapeHtml(opt_data.num) + ' patient' + ((opt_data.num != 1) ? 's' : '') + ' in common</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.eConfirmedTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('This provider has verified contact information.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.emrUserTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Elation Health user');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.passportUserTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Elation Passport user');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.mainProvidersTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('These are the providers you choose to keep in the loop on this patient\'s care.<br />Providers in this list appear in the patient\'s Clinical Profile.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.otherProvidersTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('These providers were identified by the information stored in the chart<br />as being associated with this patient\'s care. Providers in this list<br />do not appear in the patient\'s Clinical Profile.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamProvidersTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Providers actively caring for this patient.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamOtherProvidersTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('All other providers associated with this patient\'s care.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamActiveTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Sharing and access to shared records');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamActiveNotSharingTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Access to shared records');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamInactiveAndSharingTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Sharing records');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.careTeamInviteOutstandingTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Care Team invitation outstanding');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.insuranceStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.status == true) ? '<span class="padr8 el8EPNInfoTextYes"><span class="el8EPNIconYes"></span>insurance</span>' : (opt_data.status == false) ? '<span class="padr8 el8EPNInfoTextNo"><span class="el8EPNIconNo"></span>insurance</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.newPatientStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.status == true) ? '<span class="el8EPNInfoTextYes"><span class="el8EPNIconYes"></span>new pts</span>' : (opt_data.status == false) ? '<span class="el8EPNInfoTextNo"><span class="el8EPNIconNo"></span>new pts</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.providerMrHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8MRHeader">Search for Providers Named:</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.providers.specialtyMrHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="mr-subheader el8MRHeader">Matching Specialties</p>');
  if (!opt_sb) return output.toString();
};
